export default {
  computed: {
    isDesktop() {
      return this.$store.getters['common/getScreenType'] === 'desktop';
    },
    isTablet() {
      return this.$store.getters['common/getScreenType'] === 'tablet';
    },
  },
  methods: {
    closeTab(e) {
      if (e && e !== 'right') {
        e.stopPropagation();
      }
      this.$store.commit('common/closeSection', '');
      this.$store.commit('common/hideOverlay', false);
      document.querySelector('body').classList.remove('disable-scroll');
      document.body.classList.remove('modal-open');
      if (this.isDesktop || this.isTablet) {
        this.$store.commit('common/setSearchwide', false);
      }
    },
  },
};
